module.exports = __webpack_public_path__ + "static/media/craft-07@3x.4678de82.png";